import React from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductDetailsContentStyled } from '../shared/Product/ProductDetailsContentStyled';
import { Product, Variant } from '../../models/Product';

const StyledWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    borderBottom: '1px solid #e6e6e6',
    padding: '20px 0',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

const StyledBox = styled(Box)(({ theme }) => ({
    flex: '0 0 50%',
    [theme.breakpoints.down('sm')]: {
        flex: '0 0 100%',
    },
}));

export const ProductDetails = (props: {
    product: Product;
    variant: Variant;
}) => {
    const product = props.product;
    const variant = props.variant;

    const { t } = useTranslation('product');

    return (
        <StyledWrapper>
            <StyledBox>
                <ProductDetailsContentStyled
                    name={t('PRODUCT.VENDOR')}
                    value={product.vendor}
                />
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.ERP_READY')}*/}
                {/*    value={'Igen'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.ENERGY_RATING')}*/}
                {/*    value={'A'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.SEASONAL_EFFECTIVENESS')}*/}
                {/*    value={'93.00 %'}*/}
                {/*/>*/}
                <ProductDetailsContentStyled
                    name={t('PRODUCT.SKU')}
                    value={variant.sku}
                />
            </StyledBox>
            <StyledBox>
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.RATED_POWER')}*/}
                {/*    value={'19.00 kW'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.NOISE_LEVEL')}*/}
                {/*    value={'50.00 dB'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.TOTAL_RECORDED_POWER')}*/}
                {/*    value={'77 W'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.VOLTAGE_AND_FREQUENCY')}*/}
                {/*    value={'230 V, 50 Hz'}*/}
                {/*/>*/}
                {/*<ProductDetailsContentStyled*/}
                {/*    name={t('PRODUCT.QUANTITY')}*/}
                {/*    value={*/}
                {/*        variant.quantityAvailable + ' ' + t('PRODUCT.IN_STOCK')*/}
                {/*    }*/}
                {/*/>*/}
            </StyledBox>
        </StyledWrapper>
    );
};
